import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { DashboardService } from '../../../../../services/dashboard.service';
import { SharedService } from '../../../../../services/shared.service';
import { BloccoModel } from '../../../../../models/dashboard/blocco.model';

@Component({
  selector: 'app-documents-form',
  templateUrl: './documents-form.component.html',
  styleUrls: ['./documents-form.component.css']
})
export class DocumentsFormComponent implements OnInit {

  formArray: FormArray;
  blocco: any;

  getGroupValue = index => this.formArray.controls[index].value;

  constructor(
    private fb: FormBuilder,
    private _dashboardService: DashboardService,
    private _sharedService: SharedService
  ) { }

  ngOnInit() {
    this.blocco = this._sharedService.getBlocco();
    this.formArray = new FormArray([]);
    if (this.blocco.blocchiToDOWNLOAD.length) {
      for (const value of this.blocco.blocchiToDOWNLOAD) {
        this.addNewFormGroup(value);
      }
    } else {
      this.addNewFormGroup();
    }
  }

  addNewFormGroup(value?: string) {
    this.formArray.push(
      this.fb.group({ 'file': [value ? value : '', Validators.required] }));
  }

  deleteFile(index: number) {
    this._dashboardService.deleteBloccoToDOWNLOAD({ ...this.getGroupValue(index).file })
      .subscribe(
        res => {
          this.formArray.removeAt(index);
        }, err => { });
  }

  onFileChange(event, group) {
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      group.get('file').setValue(file);
      //uplaodImage
      this._dashboardService.uploadFile({ token: this.blocco.token, id: 1, file }).subscribe(
        uploadedImg => {
          //updateComponent
          this._dashboardService.createBloccoToDOWNLOAD({
            IdBlocco: this.blocco.id,
            DownloadTesto: uploadedImg.nome,
            DownloadSrc: `${this.blocco.token}/${uploadedImg.token}`,
            CreatedAt: new Date().toISOString()
          }).subscribe(
            imgToBloccoResult => { },
            err => { });
        }, err => { });
    }
  }

  canDelete(i) {
    if (this.getGroupValue(i).file !== "" && this.formArray.controls.length > 1) {
      return this.formArray.controls.map(item => {
        if (item.value !== "") {
          return true;
        }
      });
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-type-manager/forms/documents-form/documents-form.component.ts